import { appendSearchParams } from '@utils/helpers'
import { baseUrl } from '@utils/utils-config'

type SearchParamsRecord = Record<string, string | string[] | undefined>

// Kept free of any `src/lib/backend/read` import so client components can build
// a partner URL without dragging the `server-only` fetchers into the bundle.
export function buildPartnerUrl({
  publicId,
  slug,
  searchParams = {},
}: {
  publicId: number
  slug: string
  searchParams?: SearchParamsRecord
}) {
  return appendSearchParams(baseUrl(`/partner/${publicId}/${slug}/`), searchParams)
}
